<template>
    <div class="competitionVideoList">
        <div class="title">
            <div><span></span>竞赛指导视频</div>
        </div>
        <div class="inner">
            <ul class="lis">
                <li v-for="(item, index) in videoList" :key="index" @click="goPlay(item)">
                    <div class="free">
                        <div class="imgBox"><img :src="item.pic" alt=""></div>
                        <p class="text">{{item.title}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <!-- <Jihuoka v-show="isShowjihuoka" v-on:go-close="isShowjihuoka = false" ></Jihuoka> -->
    </div>
</template>
<style type="text/css" lang='less' scoped>
    .title{
        font-size: 16px !important;
        // width: 100%;
        background: #fff;
        padding: 0 15px;
        display: flex;
        > div{
            border-bottom: 1px solid #CCC;
            padding: 15px 0;
            display: flex;
            width: 100%;
        }
        span{
            width: 4px;
            // height: 100%;
            background: dodgerblue;
            margin-right: 10px;
        }
    }
    .competitionVideoList {
        margin-left: 20px;
        background: #fff;
        padding-bottom: 6px;
        .inner{
            padding-top: 6px;
        }
        .lis{
            display: flex;
            // justify-content: space-around;
            flex-wrap: wrap;
            background: #fff;
            padding: 15px 23px;
            justify-content: space-between;
            > li{
                width: 285px;
                padding: 0 10px;
                box-shadow: 0 0 1px;
                cursor: pointer;
                cursor: pointer;
                padding-top: 10px;
                margin-bottom: 20px;
                img{
                    width: 100%;
                    height:188px ;
                }
                .text{
                    line-height: 45px;
                    font-size: 14px;
                    text-align: center;
                }
                .text:hover{
                    text-decoration: underline;
                }
            }
        }
    }
</style>
<script>
// 引入激活竞赛视频卡组件
// import Jihuoka from './jihuoka.vue';
export default {
    // components: { Jihuoka },
    props: ['isFrom'],
    data() {
        return {
            isShowjihuoka: false,
            videoList: [],
            // 视频播放面包屑显示自主招生还是综合评价
        }
    },
    methods: {
        getVideoList() {
            // 竞赛指导视频名称
            var categoryName = this.$route.query.categoryName;
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken');
            this.$ajax.post(this.G_uri + '/competitionVideo/getVideoListByCategory', {
                categoryName: categoryName
            },{
                headers:{
                    token: token
                }
            })
                .then(function(res) {
                    if(res.data.code == 2000) {
                       _this.videoList = res.data.data;
                    }else if(res.data.code == 1016) {
                        _this.$router.push('/login');
                    }
                   
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        goPlay(item) {
            let isFrom = this.isFrom;
            // let _this=this;
            let {href}=this.$router.resolve({
                path: '/videoCourse/videoplay',
                query: {
                    id: item.id,
                    title: item.title,
                    introduction: item.introduction,
                    ppt: item.ppt,
                    isFrom: isFrom,
                    categoryName:this.$route.query.categoryName,
                }
            })
             window.open(href, '_blank'); 



        },
    },
    mounted(){
this.getVideoList();
    },
    created() {
        // this.getIsCanView();
        this.getVideoList();
    }
    
}
</script>